/**
 * Copyright (c) 2019, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import styled from 'styled-components';
import SubscribeWithChannel from '../SubscribeWithChannel';
import Button from '../../../../components/Button';
import Modal, { ModalFooter, ModalHeader } from '../../../../components/Modal';
import styles from '../../../../styles';

const BodyWrapper = styled.div`
  padding: 1rem;
`;

class EditGeneralMessageSubscriptionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { generalMessageEmailSubscribed: false, generalMessageSMSSubscribed: false };
  }
  submit = () => {
    const { generalMessageEmailSubscribed, generalMessageSMSSubscribed } = this.state;
    const body = {
      generalMessageEmailSubscribed,
      generalMessageSMSSubscribed,
    };
    this.props.requests.patchSubscription
      .handleRequest({ body })
      .then(() => {
        this.props.requests.subscriber.handleRequest();
        this.props.onClose('success', 'Your subscription has been successfully edited!');
      })
      .catch(error => {
        this.props.requests.subscriber.handleRequest();
        this.props.onClose('failure', 'There was an error. Please try again');
      });
  };
  '';

  componentDidMount() {
    const { generalMessageEmailSubscribed, generalMessageSMSSubscribed } = this.props.requests.subscriber.value;
    this.setState({ generalMessageEmailSubscribed, generalMessageSMSSubscribed });
  }

  toggleSubscribe = subType => {
    return () => {
      let { generalMessageEmailSubscribed, generalMessageSMSSubscribed } = this.state;
      if (subType === 'email') {
        generalMessageEmailSubscribed = !generalMessageEmailSubscribed;
      }

      if (subType === 'sms') {
        generalMessageSMSSubscribed = !generalMessageSMSSubscribed;
      }

      this.setState({
        generalMessageEmailSubscribed,
        generalMessageSMSSubscribed,
      });
    };
  };

  render() {
    const { emailAddress, phoneNumber, mobileNumberVerified } = this.props.requests.subscriber.value;
    return (
      <Modal onClose={this.props.onClose}>
        <ModalHeader text="Edit Subscription" />
        <BodyWrapper>
          <SubscribeWithChannel
            instanceKey="Informational Message"
            emailAddress={emailAddress}
            phoneNumber={phoneNumber}
            mobileNumberVerified={mobileNumberVerified}
            generalMessageEmailSubscribed={this.state.generalMessageEmailSubscribed}
            generalMessageSMSSubscribed={this.state.generalMessageSMSSubscribed}
            toggleSubscribe={this.toggleSubscribe}
          />
        </BodyWrapper>
        <ModalFooter>
          <Button onClick={this.props.onClose}>Close</Button>
          <Button theme="brand" onClick={this.submit}>
            Submit
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default EditGeneralMessageSubscriptionModal;
